<template>
  <div>
    <!-- 机构信息 -->
    <OrganInformation :dataInfo="dataInfo" :readOnly="readOnly" />

    <!-- 银行账户 -->
    <BankAccount @getCustbankbl="getCustbankbl" :readOnly="readOnly" />

    <!-- 开票信息 -->
    <InvoiceInformation :dataInfo="dataInfo" :bankData="bankData" :readOnly="readOnly" />

    <!-- 关联企业 -->
    <RelationEnterprise :readOnly="readOnly"  />

    <!-- 常用联系人 -->
    <Contacts :readOnly="readOnly" />
  </div>
</template>

<script>
import OrganInformation from "./components/organInformation.vue";
import InvoiceInformation from "./components/invoiceInformation.vue";
import BankAccount from "./components/bankAccount.vue";
import Contacts from "./components/contacts.vue";
import RelationEnterprise from "./components/relationEnterprise.vue";

export default {
  name: "assets",
  components: {
    OrganInformation,
    InvoiceInformation,
    BankAccount,
    Contacts,
    RelationEnterprise,
  },
  data() {
    return {
      bankData: [],
    };
  },
  props: {
    dataInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  
  watch: {
    dataInfo: {
      deep: true,
      handler(newName, oldName) {
        
      },
    },
  },
  methods: {
    getCustbankbl(list) {
      this.bankData=list
    },
  },
};
</script>
<style scoped lang="scss">
</style>

